"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = renderedContent;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var defaultTemplateStyle = require("./../template/template_css.js")["default"];
var defaultAppStyle = require("./../template/app_css.js")["default"];
var defaultLogoStyle = require("./../logo/logo_css.js")["default"];
var defaultLogStyle = require("./log_css.js")["default"];
function getLogo(p) {
  var logoStyle = p.logoStyle;
  return "<div class=\"".concat(logoStyle.logo, "\">\n    <div class=\"").concat(logoStyle.icon, "\">\n        <svg class=\"").concat(logoStyle.svg, "\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 252 211.72\">\n            <path d=\"M15.52,246.7c13-22.86,26-45.68,38.85-68.57Q86.31,121.39,118.19,64.6a17.15,17.15,0,0,1,5.74-5.9c11.18-6.91,22.53-13.55,33.83-20.27,1.07-.63,2.19-1.17,4.63-2.46L57.52,222.7h210v1c-6.78,3.79-13.62,7.48-20.32,11.41-7,4.08-13.8,8.38-20.68,12.59q-103.26,0-206.52,0A21.71,21.71,0,0,1,15.52,246.7Z\" transform=\"translate(-15.52 -35.97)\" />\n            <path d=\"M225.94,198.17c-9.24,0-17.66.1-26.07-.12-1.11,0-2.57-1.41-3.21-2.53q-23.55-41.67-46.87-83.45a5.41,5.41,0,0,1-.16-4.4c3.89-7.34,8.06-14.52,12.67-22.72Z\" transform=\"translate(-15.52 -35.97)\" />\n        </svg>\n    </div>\n</div>");
}
function getStyle(p) {
  var type = p.type,
    templateStyle = p.templateStyle,
    appStyle = p.appStyle,
    logoStyle = p.logoStyle,
    logStyle = p.logStyle;
  return "<style ".concat(type === "content" ? "scoped" : "", ">").concat(templateStyle._getCss(), " ").concat(appStyle._getCss(), " ").concat(logoStyle._getCss(), " ").concat(logStyle._getCss(), " </style>");
}
function getContent(p) {
  var templateStyle = p.templateStyle,
    logStyle = p.logStyle,
    text = p.text,
    copyright = p.copyright,
    toConsole = p.toConsole,
    logo = p.logo,
    footerMenu = p.footerMenu;
  return "<div class=\"".concat(templateStyle.page, "\">\n                <div class=\"").concat(templateStyle.header, "\">\n                    <div class=\"").concat(templateStyle.innerHeader, "\">\n                        <div class=\"").concat(templateStyle.logo, "\">\n                            ").concat(logo, "\n                        </div>\n                    </div>\n                </div>\n                <div class=\"").concat(templateStyle.content, "\">\n                    <div class=\"").concat(logStyle.log, "\">\n                        <div class=\"").concat(logStyle.logo, "\">\n                            ").concat(logo, "\n                        </div>\n                    <div>").concat(text, "</div>\n                    </div>\n                </div>\n                <div class=\"").concat(templateStyle.footer, "\">\n                    <div>\n                        <div class=\"").concat(templateStyle.menu, "\">\n                            ").concat(footerMenu, "\n                        </div>\n                        <div class=\"").concat(templateStyle.copyright, "\">").concat(copyright, "</div>\n                    </div>\n                </div>\n                <script>\n                window.addEventListener(\"scroll\", function (e) {\n                    const header = document.body.querySelector(\".").concat(templateStyle.header, "\");\n                    if (header){\n                        header.classList.toggle(\"").concat(templateStyle.sticky, "\", window.scrollY > 0 )\n                    }\n                });\n                if (").concat(typeof toConsole === "string", "){\n                    console.log(`").concat(toConsole, "`);\n                }\n                </script>\n            </div>");
}
function getHtml(p) {
  var title = p.title,
    style = p.style,
    content = p.content,
    appStyle = p.appStyle;
  return "<html lang=\"en\">\n    <head>\n        <meta charSet=\"utf-8\"/>\n        <title>".concat(title, "</title>\n        <meta name=\"description\" content=\"").concat(title.split(" | ")[0], "\"/>\n        <meta name=\"author\" content=\"Wapplr\"/>\n        <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\"/>\n        <link rel=\"icon\" href=\"data:image/png;base64,iVBORw0KGgo=\"/>\n        ").concat(style, "\n    </head>\n    <body>\n        <div class=\"").concat(appStyle.app, "\" id=\"wapplr-container-element-id-buildHash\">\n            ").concat(content, "\n        </div>\n    </body>\n</html>\n");
}
function renderedContent() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _p$templateStyle = p.templateStyle,
    templateStyle = _p$templateStyle === void 0 ? defaultTemplateStyle : _p$templateStyle,
    _p$appStyle = p.appStyle,
    appStyle = _p$appStyle === void 0 ? defaultAppStyle : _p$appStyle,
    _p$logoStyle = p.logoStyle,
    logoStyle = _p$logoStyle === void 0 ? defaultLogoStyle : _p$logoStyle,
    _p$logStyle = p.logStyle,
    logStyle = _p$logStyle === void 0 ? defaultLogStyle : _p$logStyle;
  var _p$title = p.title,
    title = _p$title === void 0 ? "Log | Wapplr" : _p$title,
    _p$text = p.text,
    text = _p$text === void 0 ? "[" + Date.now() + " - ::1] HTTP:1.1 GET / - [200]" : _p$text,
    _p$copyright = p.copyright,
    copyright = _p$copyright === void 0 ? "Wapplr ".concat(new Date().getFullYear(), " \xA9") : _p$copyright,
    _p$toConsole = p.toConsole,
    toConsole = _p$toConsole === void 0 ? false : _p$toConsole,
    _p$logo = p.logo,
    logo = _p$logo === void 0 ? getLogo((0, _objectSpread2["default"])({
      logoStyle: logoStyle
    }, p)) : _p$logo,
    _p$footerMenu = p.footerMenu,
    footerMenu = _p$footerMenu === void 0 ? "" : _p$footerMenu,
    _p$type = p.type,
    type = _p$type === void 0 ? "" : _p$type;
  var _p$style = p.style,
    style = _p$style === void 0 ? getStyle((0, _objectSpread2["default"])({
      templateStyle: templateStyle,
      appStyle: appStyle,
      logoStyle: logoStyle,
      logStyle: logStyle
    }, p)) : _p$style,
    _p$content = p.content,
    content = _p$content === void 0 ? getContent((0, _objectSpread2["default"])({
      templateStyle: templateStyle,
      logStyle: logStyle,
      text: text,
      copyright: copyright,
      toConsole: toConsole,
      logo: logo,
      footerMenu: footerMenu
    }, p)) : _p$content;
  if (type === "content") {
    return "".concat(content, " ").concat(style);
  }
  var _p$html = p.html,
    html = _p$html === void 0 ? getHtml((0, _objectSpread2["default"])({
      title: title,
      style: style,
      content: content,
      appStyle: appStyle
    }, p)) : _p$html;
  return html;
}